module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ANGEL LUNA")]), _c('br'), _vm._v("El Paletero")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("DANIEL ZAPIEN")]), _c('br'), _vm._v("Reflections of a Pool Builder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ANTHONY KING")]), _c('br'), _vm._v("Addiction and Redemption in Silicon Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("EDWARD NIETO")]), _c('br'), _vm._v("Blood-Sucking Machines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("K. S.")]), _c('br'), _vm._v("Turning Metal into Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ALI RAHNOMA")]), _c('br'), _vm._v("Confessions of a Cell Phone Salesman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CECILIA CHAVEZ")]), _c('br'), _vm._v("Cleaning Up the Valley Under the Table")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("TAMEEKA BENNETT")]), _c('br'), _vm._v("Lyfting Up My Income")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("SAID FARAH")]), _c('br'), _vm._v("Driving a Rickshaw in San Jose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("MIKE SANDOVAL")]), _c('br'), _vm._v("Riding the Row")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("EDWARD NIETO")]), _c('br'), _vm._v("The Sign")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ANDREW BIGELOW")]), _c('br'), _vm._v("Gold Out West")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("JEAN MELESAINE")]), _c('br'), _vm._v("New Booty at Walmart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("DAZEL VALADEZ")]), _c('br'), _vm._v("Eulogy to My Mall Job")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("MIKE NICE")]), _c('br'), _vm._v("Sometimes It’s Fun, Sometimes There’s Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("FERNANDO PEREZ")]), _c('br'), _vm._v("Second-Hand Hustlin’ in Silicon Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ALEX GUTIERREZ")]), _c('br'), _vm._v("Working at the Porn Shop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("YAVETH GOMEZ")]), _c('br'), _vm._v("Living in My Car")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("LAMAR WILLIAMS")]), _c('br'), _vm._v("Young, Black, and Homeless in San Jose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ALEX GUTIERREZ")]), _c('br'), _vm._v("Motel 22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("JUSTIN COLLINS")]), _c('br'), _vm._v("The Tao of Hustle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("SHANA WHITE")]), _c('br'), _vm._v("Don’t Call Me Lunch Lady")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CESAR FLORES")]), _c('br'), _vm._v("Serving Up Silicon Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ADRIAN AVILA")]), _c('br'), _vm._v("America, Mom, and BBQ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CECILIA CHAVEZ")]), _c('br'), _vm._v("To Those Who May Hire My Dad in the Parking Lot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("GABRIEL")]), _c('br'), _vm._v("America from the Back of a Pickup Truck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ANGEL LUNA")]), _c('br'), _vm._v("America Is in Me, and so Is My Accent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("DAVID MADRID")]), _c('br'), _vm._v("Translating at Target")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("VICTOR SALDANA")]), _c('br'), _vm._v("Once a Temp, Always a Temp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("EDWARD NIETO")]), _c('br'), _vm._v("Brave New Field")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ANGEL LUNA")]), _c('br'), _vm._v("Trade School Scams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("SHAMAKO NOBLE")]), _c('br'), _vm._v("The Elevator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("IRENE EDAN")]), _c('br'), _vm._v("I Used to Lay People Off, Then It Happened to Me")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("TOM DEARBORNE")]), _c('br'), _vm._v("Finding Work after Thirty-Four Years in Prison")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ALEX GUTIERREZ")]), _c('br'), _vm._v("Rebirth through Finding a New Job")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("HOUNG NGUYEN")]), _c('br'), _vm._v("The World of Ma’s Salon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("LIZ GONZALEZ")]), _c('br'), _vm._v("The Connected Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ABOUT THE EDITORS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0